export enum AchievementId {
  CAMPAIGN_ALL_STAGES = 'CAMPAIGN_ALL_STAGES',
  CAMPAIGN_ALL_MONSTERS = 'CAMPAIGN_ALL_MONSTERS',

  // トーナメント戦 - 値は後方互換のため旧名を維持
  TOURNAMENT_ELIMINATION_CHAMPION_LV1 = 'TOURNAMENT_CHAMPION_LV1',
  TOURNAMENT_ELIMINATION_CHAMPION_LV2 = 'TOURNAMENT_CHAMPION_LV2',
  TOURNAMENT_ELIMINATION_CHAMPION_LV3 = 'TOURNAMENT_CHAMPION_LV3',
  TOURNAMENT_ELIMINATION_CHAMPION_LV4 = 'TOURNAMENT_CHAMPION_LV4',
  TOURNAMENT_ELIMINATION_CHAMPION_LV5 = 'TOURNAMENT_CHAMPION_LV5',
  TOURNAMENT_ELIMINATION_CHAMPION_LV6 = 'TOURNAMENT_CHAMPION_LV6',

  // 総当たり大会
  TOURNAMENT_ROUND_ROBIN_CHAMPION_LV1 = 'TOURNAMENT_ROUND_ROBIN_CHAMPION_LV1',
  TOURNAMENT_ROUND_ROBIN_CHAMPION_LV2 = 'TOURNAMENT_ROUND_ROBIN_CHAMPION_LV2',
  TOURNAMENT_ROUND_ROBIN_CHAMPION_LV3 = 'TOURNAMENT_ROUND_ROBIN_CHAMPION_LV3',
  TOURNAMENT_ROUND_ROBIN_CHAMPION_LV4 = 'TOURNAMENT_ROUND_ROBIN_CHAMPION_LV4',
  TOURNAMENT_ROUND_ROBIN_CHAMPION_LV5 = 'TOURNAMENT_ROUND_ROBIN_CHAMPION_LV5',
  TOURNAMENT_ROUND_ROBIN_CHAMPION_LV6 = 'TOURNAMENT_ROUND_ROBIN_CHAMPION_LV6',

  SURVIVAL_WIN_10 = 'SURVIVAL_WIN_10',
  SURVIVAL_WIN_20 = 'SURVIVAL_WIN_20',
  SURVIVAL_WIN_30 = 'SURVIVAL_WIN_30',
  SURVIVAL_WIN_40 = 'SURVIVAL_WIN_40',
  SURVIVAL_WIN_50 = 'SURVIVAL_WIN_50',
  SURVIVAL_WIN_60 = 'SURVIVAL_WIN_60',
  SURVIVAL_WIN_70 = 'SURVIVAL_WIN_70',
  SURVIVAL_WIN_80 = 'SURVIVAL_WIN_80',
  SURVIVAL_WIN_90 = 'SURVIVAL_WIN_90',
  SURVIVAL_WIN_100 = 'SURVIVAL_WIN_100',

  // 隠しキャラ解放
  UNLOCK_ALICE = 'UNLOCK_ALICE',
  UNLOCK_MOCOCO = 'UNLOCK_MOCOCO',
}

export interface AchievementData {
  unlocked: AchievementId[];
}
